// extracted by mini-css-extract-plugin
export default {"LayerList":"FoilLayersTabContent_LayerList__efBCm","subtitle":"FoilLayersTabContent_subtitle__xdQPu","hint":"FoilLayersTabContent_hint__YVVaL"};